import React from 'react';
import { Link } from '@material-ui/core';
import AttachmentIcon from '@material-ui/icons/Attachment';
import { resolveMediaUrl } from '../../helpers/resolveMediaUrl';

export default function EmailAttachment ({ messageAttachment }) {
	return (
		<Link
			variant={'caption'}
			href={resolveMediaUrl(messageAttachment)}
			download={messageAttachment}
			target="_blank"
			rel="noopener noreferrer"
			underline="always"
		>
			<span style={{ display: 'flex' }}>
				<AttachmentIcon fontSize="small" />
				{messageAttachment}
			</span>
		</Link>
	);
}
